import { useState } from 'react';

export default function Footer() {
  const [moreOpen, setMoreOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(null);

  function handleMoreClick() {
    if (moreOpen) setActiveSection(null);
    setMoreOpen(!moreOpen);
  }

  function handleTitleClick(key) {
    setActiveSection(prev => prev === key ? null : key);
  }

  return (
    <footer className="footer">
      <div className="footer-bar">
        <span className="footer-motto">Ownership. Transparency. Creator-first economy.</span>
      </div>

      <div className="footer-bottom-wrapper">
        <div className={`footer-content ${moreOpen ? 'footer-content-open' : ''}`}>
          <div className={`footer-links ${activeSection === 'socials' ? 'footer-links-active' : ''}`}>
            <span className="footer-section-title" onClick={() => handleTitleClick('socials')}>Socials</span>
            <div className="footer-section-items">
              <div className="footer-socials-grid">
                <a href="https://x.com/finema_io" target="_blank" rel="noopener noreferrer">X</a>
                <a href="https://instagram.com/finema_io" target="_blank" rel="noopener noreferrer">Instagram</a>
              </div>
            </div>
          </div>

          <div className={`footer-links ${activeSection === 'platform' ? 'footer-links-active' : ''}`}>
            <span className="footer-section-title" onClick={() => handleTitleClick('platform')}>Platform</span>
            <div className="footer-section-items">
              <a href="/explore">Explore</a>
              <a href="/login">Log In</a>
              <a href="/register">Sign Up</a>
            </div>
          </div>

          <div className={`footer-links ${activeSection === 'legal' ? 'footer-links-active' : ''}`}>
            <span className="footer-section-title" onClick={() => handleTitleClick('legal')}>Legal</span>
            <div className="footer-section-items">
              <a href="#">Terms</a>
              <a href="#">Privacy</a>
            </div>
          </div>

          <div className={`footer-links ${activeSection === 'contact' ? 'footer-links-active' : ''}`}>
            <span className="footer-section-title" onClick={() => handleTitleClick('contact')}>Contact</span>
            <div className="footer-section-items">
              <a href="mailto:contact@finema.io">contact@finema.io</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <button className="footer-more-btn" onClick={handleMoreClick}>
            {moreOpen ? 'Less' : 'More info'}
            <svg className={`footer-more-arrow ${moreOpen ? 'footer-more-arrow-open' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 15 12 9 18 15" />
            </svg>
          </button>
          <span>&copy; 2026 Finema. All rights reserved.</span>
          <img src="/hand.svg" alt="Finema" className="footer-bottom-logo" />
          <div className="footer-bottom-powered">
            <span className="footer-powered-label">Powered by</span>
            <svg className="footer-base-logo" viewBox="0 0 111 111" xmlns="http://www.w3.org/2000/svg">
              <circle cx="55.5" cy="55.5" r="55.5" fill="#0052FF"/>
              <path d="M55.4 93.5c-20.9 0-37.9-17-37.9-37.9s17-37.9 37.9-37.9c18.6 0 34.1 13.5 37.2 31.2H65.3c-2.7-7.5-9.9-12.9-18.4-12.9-10.8 0-19.5 8.7-19.5 19.5s8.7 19.5 19.5 19.5c8.5 0 15.7-5.4 18.4-12.9h27.4c-3.1 17.8-18.7 31.4-37.3 31.4z" fill="#fff"/>
            </svg>
            <span className="footer-chain-name">Base</span>
          </div>
        </div>
      </div>

    </footer>
  );
}
